exports = module.exports = require("/home/kwok/projects/brewplanner/brewplanner-ui/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".icon-and-section-view{font-family:\"Roboto\",sans-serif!important;font-size:14px!important;-webkit-font-smoothing:antialiased!important;-moz-osx-font-smoothing:grayscale!important;line-height:1.42857!important;color:#333!important;background-color:#fff}.icon-and-section-view .admin-scaffolding-content{padding:20px}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/views/IconsAndSectionsAdmin/IconsAndSectionsAdmin.scss
 ** module id = 291
 ** module chunks = 0
 **/